import {
  CloseSquareIcon_default
} from "./chunk-FY273SAQ.mjs";
export {
  CloseSquareIcon_default as default
};
